import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  styled,
} from "@mui/material";
import image1 from "../../../../assets/img12.jpeg";
// import image3 from "../../../../assets/ground-bg.jpg";
import Footer from "../../../../common/Footer";
import Header from "../../../../common/Header";
import { useNavigate } from "react-router-dom";

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "100%",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  margin: 0,
  padding: 0,
});

const DotsContainer = styled("div")({
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  zIndex: 10,
  pointerEvents: "auto",
});

const Dot = styled("div")(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "white",
    transform: "scale(1.2)",
  },
}));

const PublicSpeech = () => {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollWidth = container.scrollWidth;
    const itemWidth = scrollWidth / images.length;
    container.scrollTo({ left: itemWidth * index, behavior: "smooth" });
    setCurrentIndex(index);
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.offsetWidth;
    const index = Math.round(scrollLeft / itemWidth);
    setCurrentIndex(index);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const navigate = useNavigate();

  const images = [image1];

  useEffect(() => {
    const container = scrollRef.current;
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollWidth = container.scrollWidth;
      const itemWidth = scrollWidth / images.length;
      const newIndex = Math.round(container.scrollLeft / itemWidth);
      setCurrentIndex(newIndex);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      handleDotClick(nextIndex);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <>
      <Grid container>
        <Header />

        {/* Hero Section */}
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            width: "100%",
            height: { xs: "50vh", md: "65vh" },
            position: "relative",
          }}
        >
          <ScrollContainer ref={scrollRef}>
            {images.map((img, index) => (
              <ScrollItem key={index}>
                <ScrollImage src={img} alt={`Banner ${index + 1}`} />
              </ScrollItem>
            ))}
          </ScrollContainer>

          <DotsContainer>
            {images.map((_, idx) => (
              <Dot
                key={idx}
                active={currentIndex === idx}
                onClick={() => handleDotClick(idx)}
              />
            ))}
          </DotsContainer>
        </Grid>
        {/* Content Section Below */}
        <Grid item xs={12} md={12}>
          <Grid
            sx={{
              color: "#7f6b56",
              fontFamily: "Inter, sans-serif",
              px: { xs: 2, sm: 3 },
              py: { xs: 4, sm: 6 },
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              maxWidth={{ xs: "100%", sm: "md" }}
              width="100%"
              textAlign="center"
              sx={{
                border: "1px solid #7f6b56",
                p: { xs: 2, sm: 3 },
                borderRadius: 3,
                boxSizing: "border-box",
              }}
            >
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: { xs: "1.6rem", sm: "2.125rem" },
                  lineHeight: 1.2,
                }}
              >
                Public Speech Competition: Young Voices for a Rising Cause
              </Typography>
              <Divider sx={{ bgcolor: "#7f6b56", mb: { xs: 2, sm: 3 } }} />

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                In the speech contest, students showcased their oratory skills
                by highlighting scientific insights, cultural connections, and
                personal reflections on sea-level rise. Their speeches
                emphasized the urgency of climate action and the importance of
                protecting island ecosystems.{" "}
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                Each speech served as a powerful reminder that the youth are not
                only aware of the environmental challenges ahead but are also
                ready to lead conversations around sustainability. Their voices
                reflected both hope and determination in the face of rising sea
                levels.{" "}
              </Typography>

              {/* <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
                sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}
              >
                Preserving a Traditional Skill
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                Neera tapping, the practice of extracting fresh, unfermented sap from coconut palms, has been an integral part of Lakshadweep’s history. However, with modernization and changing economic trends, this traditional skill has been gradually declining. To address this, REEF has taken the initiative to document and promote indigenous knowledge among the younger generation and the local community.
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                During the session, Kunhikoya Mammail demonstrated the intricate process of neera tapping, explaining the tools used, the techniques involved, and the importance of preserving the quality of neera. They shared personal anecdotes from their years of experience and emphasized the dedication required to master the skill. Their storytelling approach engaged the audience, particularly the students, who showed keen interest in learning about this disappearing tradition.
              </Typography>

              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
                sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}
              >
                Engaging the Youth and Community
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                The event attracted a diverse audience, including students, teachers, local artisans, and community elders, all eager to learn from Kunhikoya Mammail’s expertise. Interactive discussions allowed students to ask questions about the sustainability of neera tapping and its economic potential.
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                Raheem DA, Director of Operations, honored the resource persons in recognition of their valuable contribution to preserving this traditional skill. Shaheem, Project Coordinator, welcomed the guests and gathering, setting the stage for an insightful and engaging session. REEF’s efforts to bridge the gap between generations and promote traditional knowledge were highly appreciated by participants. The program highlighted how neera tapping not only contributes to the local economy but also plays a role in ecological conservation by encouraging the sustainable use of coconut palms.
              </Typography>

              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
                sx={{ mt: { xs: 3, sm: 4 }, fontFamily: "Montserrat, sans-serif", textAlign: "left", fontSize: { xs: "1.25rem", sm: "1.375rem" } }}
              >
                A Call for Conservation and Revival
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                In their closing remarks, Kunhikoya Mammail expressed their hopes for the revival of neera tapping in Lakshadweep. They urged young people to take an interest in learning the craft, emphasizing that preserving such traditional skills is crucial for maintaining the island’s unique identity.
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 1,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                The event concluded with a commitment from REEF to continue its efforts in documenting and safeguarding indigenous practices. Community members and students left the session with a newfound appreciation for neera tapping, inspired to play a role in keeping this valuable tradition alive.
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                At the end of the program, Safair Ali Jereesh, Environmental Education Coordinator, proposed the vote of thanks, expressing gratitude to the resource persons, guests, and participants for making the event a success.
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 500,
                }}
              >
                Through initiatives like <em>A Heritage to Preserve</em>, REEF is ensuring that the wisdom of elders like Kunhikoya Mammail is passed down to future generations, keeping Lakshadweep’s cultural heritage vibrant and resilient.
              </Typography> */}
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ maxWidth: 700, margin: "0 auto", pX: 3, pb: 2 }}>
          <Grid container spacing={5}>
            {/* First Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image1}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/empowering-communities")}
                >
                  Empowering Communities, Protecting Oceans
                </Typography>
              </Box>
            </Grid> */}

            {/* Second Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image2}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/restoring-hope")}
                >
                  Restoring Hope, One Coral at a Time
                </Typography>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </Grid>
      <Footer variant="light" />
    </>
  );
};

export default PublicSpeech;
